export default __webpack_public_path__ + "static/media/catamaran.88da9581.webp";